'use client';

import { ThemeProvider } from 'next-themes';
import { HeroUIProvider } from '@heroui/react';
import { ProgressProvider } from '@bprogress/next/app';

export default function BaseWrapper({ children }: React.PropsWithChildren) {
  return (
    <ThemeProvider enableSystem={true} attribute={['class', 'data-prefers-color-scheme']}>
      <ProgressProvider height="3px" color="#4189FD" options={{ showSpinner: false }} shallowRouting>
        <HeroUIProvider>{children}</HeroUIProvider>
      </ProgressProvider>
    </ThemeProvider>
  );
}
